<template>
  <tr :data-automation="pkg.filename + '-package'">
    <td class="distributionList">
      <a
        target="_blank"
        :href="pkg.URL"
      >
        {{ pkg.filename }}
      </a>
      <span style="padding: 4px;">
        <span
          v-if="pkg.yanked"
          class="yanked"
        >
          YANKED
        </span>
      </span>
    </td>
    <td class="distributionList">
      <button
        class="copyButton"
        @click.prevent="handleShowFileHash"
      >
        Hash
      </button>
    </td>
    <FileHashModal
      v-if="showFileHash"
      :pkg="pkg"
      @closeDialog="closeFileHash"
    />
  </tr>
</template>

<script>
import FileHashModal from './FileHashModal'

export default {
  name: 'DistributionItem',
  components: {
    FileHashModal,
  },
  props: {
    pkg: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      showFileHash: false,
    }
  },
  methods: {
    handleShowFileHash: function () {
      this.showFileHash = true
    },
    closeFileHash: function () {
      this.showFileHash = false
    },
  },
}

</script>
